export default function useRouteChange() {
  const routeToCheckout = (params = null) => {
    let url = '/shop/shopkoeb'
    if (params !== null) {
      url += params
    }
    window.location.href = url
  }
  return {
    routeToCheckout
  }
}
